import type { FrameData } from './types';

export function isValidData(value: unknown): value is FrameData {
  if (typeof value !== 'object' || value === null) return false;
  const v = value as Record<string, unknown>;
  return (
    typeof v.title === 'string' &&
    typeof v.fill === 'string' &&
    typeof v.stroke === 'string' &&
    typeof v.strokeOpacity === 'number' &&
    (v.strokeStyle === 'solid' || v.strokeStyle === 'dashed' || v.strokeStyle === 'dotted') &&
    typeof v.titleColor === 'string' &&
    typeof v.fillOpacity === 'number' &&
    typeof v.collapsed === 'boolean' &&
    typeof v.icon === 'string' &&
    Array.isArray(v.childOrder)
  );
}
